<div class="paginator m-t-2">
  <tp-paginator-title
    [pageIndex]="paginatorOptions.pageIndex"
    [pageSize]="paginatorOptions.pageSize"
    [total]="paginatorOptions.length"
  ></tp-paginator-title>

  <div *ngIf="isPageChangeAvailable" class="paginator__toolbar">
    <div class="paginator__pages-wrapper m-r-2">
      <!-- Prev page -->
      <button
        class="paginator__arrow-btn"
        [disabled]="paginatorOptions.pageIndex === 0"
        (click)="changePageIndex(paginatorOptions.pageIndex - 1)"
      >
        <tp-icon [name]="'icons/arrow-left'"></tp-icon>
      </button>

      <!-- Indexed pages -->
      <div class="paginator__indexed-pages">
        <div
          *ngFor="let pageNumber of displayedPageNumbers; let i = index"
          class="paginator__indexed-page"
          [class.paginator__indexed-page--selected]="paginatorOptions.pageIndex === pageNumber - 1"
          (click)="changePageIndex(pageNumber - 1)"
        >
          {{ pageNumber }}
        </div>
      </div>

      <!-- Next page -->
      <button
        class="paginator__arrow-btn"
        [disabled]="paginatorOptions.pageIndex === pagesCount - 1"
        (click)="changePageIndex(paginatorOptions.pageIndex + 1)"
      >
        <tp-icon [name]="'icons/arrow-right'"></tp-icon>
      </button>
    </div>

    <tp-dropdown
      class="paginator__page-size-dropdown"
      [options]="pageSizeOptions"
      [(ngModel)]="selectedSizeOption"
      (ngModelChange)="updatePageSize($event)"
    ></tp-dropdown>
  </div>
</div>
